<template>
  <div id="filter-table" class="tw-absolute tw-right-0 tw-bg-white tw-top-12 tw-shadow-lg tw-rounded-md tw-z-10 tw-p-4" v-if="isVisible">
    <div class="tw-flex tw-flex-row">
      <div class="tw-w-72 tw-p-1">
        <v-menu
          ref="menuDocsDateRange"
          v-model="filter.menuDocsDateRange"
          :close-on-content-click="false"
          :return-value.sync="filter.docsDateRange"
          transition="scale-transition"
          offset-y
          min-width="290px">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              class="m-0 p-0"
              outlined
              label="ช่วงวันที่เอกสาร"
              v-model="docsDateRangeText"
              readonly
              v-bind="attrs"
              v-on="on"
              hide-details="true">
              <template v-slot:append>
                <img width="22" height="18" class="tw-mt-1 tw-cursor-pointer" src="/images/icons/icon_calendar.svg"
                     v-on="on"/>
              </template>
            </v-text-field>
          </template>
          <v-date-picker locale="th-TH" v-model="filter.docsDateRange" range no-title scrollable>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="filter.menuDocsDateRange = false">
              Cancel
            </v-btn>
            <v-btn text color="primary" @click="$refs.menuDocsDateRange.save(filter.docsDateRange)">
              OK
            </v-btn>
          </v-date-picker>
        </v-menu>
      </div>
      <div class="tw-w-72 tw-p-1">
        <v-text-field
          v-model="filter.docsNumber"
          label="เลขที่เอกสาร"
          outlined
          hide-details="true"
        ></v-text-field>
      </div>
    </div>
    <div class="tw-flex tw-flex-row">
      <div class="tw-w-72 tw-p-1">
        <v-text-field
          v-model="filter.buyerCode"
          label="รหัสผู้ซื้อ"
          outlined
          hide-details="true"
        ></v-text-field>
      </div>
      <div class="tw-w-72 tw-p-1">
        <v-text-field
          v-model="filter.buyerBranch"
          label="สาขาผู้ซื้อ"
          outlined
          hide-details="true"
        ></v-text-field>
      </div>
    </div>
    <div class="tw-flex tw-flex-row">
      <div class="tw-w-48 tw-p-1">
        <v-select
          v-model="filter.productValueOperator"
          :items="operators"
          label="ช่วงมูลค่าสินค้า"
          outlined
          hide-details="true">
          <template v-slot:append>
            <img width="14" height="14" class="tw-mt-1 tw-mr-1" src="/images/icon-angle-down.svg"/>
          </template>
        </v-select>
      </div>
      <div class="tw-w-48 tw-p-1">
        <v-text-field
          v-model="filter.productValue0"
          :label="filter.productValueOperator === 'range' ? 'มูลค่าเริ่มต้น' : 'มูลค่าสินค้า'"
          outlined
          hide-details="true"
        ></v-text-field>
      </div>
      <div class="tw-w-48 tw-p-1" v-if="filter.productValueOperator === 'range'">
        <v-text-field
          v-model="filter.productValue1"
          label="มูลค่าสิ้นสุด"
          outlined
          hide-details="true"
        ></v-text-field>
      </div>
    </div>
    <div class="tw-flex tw-flex-row">
      <div class="tw-w-48 tw-p-1">
        <v-select
          v-model="filter.vatOperator"
          :items="operators"
          label="ช่วงภาษีมูลค่าเพิ่ม"
          outlined
          hide-details="true">
          <template v-slot:append>
            <img width="14" height="14" class="tw-mt-1 tw-mr-1" src="/images/icon-angle-down.svg"/>
          </template>
        </v-select>
      </div>
      <div class="tw-w-48 tw-p-1">
        <v-text-field
          v-model="filter.vat0"
          :label="filter.vatOperator === 'range' ? 'มูลค่าเริ่มต้น' : 'ภาษีมูลค่าเพิ่ม'"
          outlined
          hide-details="true"
        ></v-text-field>
      </div>
      <div class="tw-w-48 tw-p-1" v-if="filter.vatOperator === 'range'">
        <v-text-field
          v-model="filter.vat1"
          label="มูลค่าสิ้นสุด"
          outlined
          hide-details="true"
        ></v-text-field>
      </div>
    </div>
    <div class="tw-flex tw-flex-row">
      <div class="tw-w-48 tw-p-1">
        <v-select
          v-model="filter.totalOperator"
          :items="operators"
          label="ช่วงยอดรวม"
          outlined
          hide-details="true">
          <template v-slot:append>
            <img width="14" height="14" class="tw-mt-1 tw-mr-1" src="/images/icon-angle-down.svg"/>
          </template>
        </v-select>
      </div>
      <div class="tw-w-48 tw-p-1">
        <v-text-field
          v-model="filter.total0"
          :label="filter.totalOperator === 'range' ? 'มูลค่าเริ่มต้น' : 'ยอดรวม'"
          outlined
          hide-details="true"
        ></v-text-field>
      </div>
      <div class="tw-w-48 tw-p-1" v-if="filter.totalOperator === 'range'">
        <v-text-field
          v-model="filter.total1"
          label="มูลค่าสิ้นสุด"
          outlined
          hide-details="true"
        ></v-text-field>
      </div>
    </div>
    <div class="tw-flex tw-flex-row">
      <div class="tw-w-72 tw-p-1">
        <v-menu
          ref="menuSignDateRange"
          v-model="filter.menuSignDateRange"
          :close-on-content-click="false"
          :return-value.sync="filter.signDateRage"
          transition="scale-transition"
          offset-y
          min-width="290px">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              outlined
              label="ช่วงเวลาลงลายมือชื่อ"
              v-model="signDateRageText"
              readonly
              v-bind="attrs"
              v-on="on"
              hide-details="true">
              <template v-slot:append>
                <img width="22" height="18" class="tw-mt-1 tw-cursor-pointer" src="/images/icons/icon_calendar.svg"
                     v-on="on"/>
              </template>
            </v-text-field>
          </template>
          <v-date-picker v-model="filter.signDateRage" range no-title scrollable>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="filter.menuSignDateRange = false">
              Cancel
            </v-btn>
            <v-btn text color="primary" @click="$refs.menuSignDateRange.save(filter.signDateRage)">
              OK
            </v-btn>
          </v-date-picker>
        </v-menu>
      </div>
      <div class="tw-w-72 tw-p-1">
        <v-select
          v-model="filter.docsType"
          :items="docsTypeList"
          label="ประเภทเอกสาร"
          outlined
          hide-details="true">
          <template v-slot:append>
            <img width="14" height="14" class="tw-mt-1 tw-mr-1" src="/images/icon-angle-down.svg"/>
          </template>
        </v-select>
      </div>
    </div>
    <div class="tw-flex tw-flex-row tw-mt-3">
      <div class=""><b>สถานะเอกสาร</b></div>
    </div>
    <div class="tw-flex tw-flex-row">
      <div class="tw-w-72">
        <v-checkbox
          class="tw-mt-0"
          v-model="filter.status.xmlDownloadSuccess"
          label="ดาวน์โหลด XML แล้ว"
          :hide-details="true"
        ></v-checkbox>
      </div>
      <div class="tw-w-72">
        <v-checkbox
          class="tw-mt-0"
          v-model="filter.status.emailNotFound"
          label="ไม่มีข้อมูลอีเมล"
          :hide-details="true"
        ></v-checkbox>
      </div>
    </div>
    <div class="tw-flex tw-flex-row">
      <div class="tw-w-72">
        <v-checkbox
          class="tw-mt-0"
          v-model="filter.status.xmlNotDownload"
          label="ยังไม่ได้ดาวน์โหลด XML"
          :hide-details="true"
        ></v-checkbox>
      </div>
      <div class="tw-w-72">
        <v-checkbox
          class="tw-mt-0"
          v-model="filter.status.emailSentSuccess"
          label="ส่งอีเมลเรียบร้อย"
          :hide-details="true"
        ></v-checkbox>
      </div>
    </div>
    <div class="tw-flex tw-flex-row">
      <div class="tw-w-72">
        <v-checkbox
          class="tw-mt-0"
          v-model="filter.status.signSuccess"
          label="เซ็นเอกสารเรียบร้อย"
          :hide-details="true"
        ></v-checkbox>
      </div>
      <div class="tw-w-72">
        <v-checkbox
          class="tw-mt-0"
          v-model="filter.status.emailSentFail"
          label="ส่งอีเมลไม่สำเร็จ"
          :hide-details="true"
        ></v-checkbox>
      </div>
    </div>
    <div class="tw-flex tw-flex-row">
      <div class="tw-w-72">
        <v-checkbox
          class="tw-mt-0"
          v-model="filter.status.missingInfo"
          label="เอกสารที่ข้อมูลไม่ครบ"
          :hide-details="true"
        ></v-checkbox>
      </div>
<!--      <div class="tw-w-72">-->
<!--        <v-checkbox-->
<!--          class="tw-mt-0"-->
<!--          v-model="filter.status.docsPermanent"-->
<!--          label="เอกสารเก็บถาวร"-->
<!--          :hide-details="true"-->
<!--        ></v-checkbox>-->
<!--      </div>-->
    </div>
    <div class="tw-flex tw-flex-row tw-mt-3">
      <div class=""><b>แสดงเฉพาะสถานะเอกสาร</b></div>
    </div>
    <div class="tw-flex tw-flex-row">
      <div class="tw-w-72">
        <v-checkbox
          class="tw-mt-0"
          v-model="filter.status.suspendedAccount"
          label="เอกสารบัญชีพัก"
          :hide-details="true"
        ></v-checkbox>
      </div>
    </div>
    <div class="tw-flex tw-flex-row tw-float-right">
      <div>
        <button class="bt-clear tw-px-4 tw-py-2 tw-rounded-md tw-text-gray-500" @click="reset">
          <v-icon left class="icon tw-w-24px tw-h-24px tw-text-gray-500">mdi-close-circle-outline</v-icon>
          <span class="text">ล้างข้อมูล</span>
        </button>
      </div>
      <div>
        <v-hover v-slot="{ hover }">
          <button
            class="group hover:tw-bg-light-green hover:tw-text-white tw-px-4 tw-py-2 tw-rounded-md tw-text-light-green"
            @click="onClickFilter">
            <img src="/images/icons/icon_search_light_green.svg" class="tw-float-left tw-mt-0.5 tw-mr-2 tw-fill-red"
                 v-if="!hover"/>
            <img src="/images/icons/icon_search_white.svg" class="tw-float-left tw-mt-0.5 tw-mr-2 tw-fill-red"
                 v-if="hover"/>
            <span>ค้นหา</span>
          </button>
        </v-hover>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FilterTable',
  props: ['isVisible', 'setFilterTable'],
  components: {},
  data: function () {
    return {
      operators: [
        {text: "ระหว่าง", value: "range"},
        {text: "เท่ากับ", value: "equal"},
        {text: "ไม่เท่ากับ", value: "not_equal"},
        {text: "น้อยกว่าหรือเท่ากับ", value: "lte"},
        {text: "มากกว่า", value: "gt"},
        {text: "มากกว่าหรือเท่ากับ", value: "gte"},
      ],
      docsTypeList: [
        {text: "ใบกำกับภาษีเต็มรูป", value: "TX"},
        {text: "ใบกำกับภาษีอย่างย่อ", value: "AB"},
        {text: "ใบเพิ่มหนี้", value: "DR"},
        {text: "ใบลดหนี้", value: "CR"},
        {text: "ใบรับ", value: "RE"},
        {text: "ใบเสร็จรับเงิน/ใบกำกับภาษี", value: "RT"},
        {text: "ใบแจ้งยกเลิก", value: "CL"},
      ],

      filter: {
        docsDateRange: [],
        menuDocsDateRange: false,
        docsNumber: "",
        buyerCode: "",
        buyerBranch: "",

        productValueOperator: "",
        productValue0: "",
        productValue1: "",

        vatOperator: "",
        vat0: "",
        vat1: "",

        totalOperator: "",
        total0: "",
        total1: "",

        signDateRage: [],
        menuSignDateRange: false,

        docsType: "",

        status: {
          xmlDownloadSuccess: false,
          xmlNotDownload: false,
          signSuccess: false,
          missingInfo: false,

          emailNotFound: false,
          emailSentSuccess: false,
          emailSentFail: false,
          // docsPermanent: false,
          suspendedAccount: null
        },


      }
    }
  },
  computed: {
    docsDateRangeText() {
      let newDateArr = []
      this.filter.docsDateRange.forEach((date)=> {
        let [year, month, day] = date.split('-')
        newDateArr.push(`${day}/${month}/${parseInt(year) + 543}`)
      })
      return newDateArr.join(' ~ ')
    },
    signDateRageText() {
      let newDateArr = []
      this.filter.signDateRage.forEach((date)=> {
        let [year, month, day] = date.split('-')
        newDateArr.push(`${day}/${month}/${parseInt(year) + 543}`)
      })
      return newDateArr.join(' ~ ')
    },
  },
  methods: {
    onClickFilter() {
      this.setFilterTable(this.filter)
    },
    reset() {
      Object.assign(this.$data, this.$options.data.call(this));
    }
  }
}
</script>

<style lang="scss">
#filter-table {
  .bt-clear:hover {
    background-color: #6ec39b;

    .text {
      color: white !important;
    }

    .icon {
      color: white !important;
    }
  }

  .v-text-field--outlined, .v-text-field--solo {
    border-radius: 10px;
  }

  .v-select__selections {
    padding: 1px 0;
  }

  .v-input__slot {
    min-height: 50px;
  }

}
</style>
